export const translationMap: { [key: string]: string } = {
    "Not enough quantity": "Không đủ số lượng",
    // Bạn có thể thêm nhiều thông báo khác vào đây nếu cần
    // "Item not found": "Không tìm thấy mặt hàng"
};